import { createAction } from '@reduxjs/toolkit';

export const setActiveCompany = createAction('ancillaryRequest/setActiveCompany');
